/* eslint-disable-next-line */
import colors from '!!sass-variable-loader!../pre-customization/_colors.scss';

export default colors;
